import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "pagination-container" }
const _hoisted_2 = {
  key: 0,
  class: "pagination-slot-top"
}
const _hoisted_3 = {
  key: 1,
  class: "pagination-slot-left"
}
const _hoisted_4 = {
  key: 2,
  class: "pagination"
}
const _hoisted_5 = {
  key: 3,
  class: "pagination-small"
}

import { PropType, computed, useSlots } from "vue";
import TirPmPaginationItem from "./tir-pm-pagination-item.vue";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from "tir-style-system/icons/solid";
import TirPmPaginationShowMoreElements from "./tir-pm-pagination-show-more-elements.vue";
import { ITirPmDropdownOption } from "tir-components";

// import IconPageFirst from "../assets/icons/page-first.svg";
// import IconPageLast from "../assets/icons/page-last.svg";
// import IconChevronLeft from "../assets/icons/chevron-left.svg";
// import IconChevronRight from "../assets/icons/chevron-right.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-pagination',
  props: {
  countElements: {type: Number as PropType<number>},
  /**
   * Отображение блока для указания кол-ва элементов
   */
  showMoreElements: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Опции для showMoreElements
   */
  options: { type: Array as PropType<number[]> },
  /**
   * Общее количество страниц
   */
  pages: {
    type: Number as PropType<number>,
    default: 0,
  },
  /**
   * Разбег между страницами
   */
  rangeSize: {
    type: Number as PropType<number>,
    default: 1,
  },
  /**
   * Текущее значение страницы
   */
  modelValue: {
    type: Number as PropType<number>,
    default: 0,
  },
  /**
   * Скрывать первую кнопку
   */
  isHideFirstButton: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Скрывать последнюю кнопку
   */
  isHideLastButton: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Минимальная пагинация без отображения кнопок соседних страниц
   */
  isSmall: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  emits: ["update:modelValue", "update:countElements"],
  setup(__props, { emit }) {

const props = __props;





const slots = useSlots();

/**
 * Сверху для кнопки
 */
const isTopSlot = computed(() => slots && slots.topSlot && slots.topSlot());
/**
 * Слот для прочего
 */
const isLeftSlot = computed(() => slots && slots.leftSlot && slots.leftSlot());

const innerCountElements = computed({
  get: () => props.countElements,
  set: (count: number) => {
    emit("update:countElements", count);
  },
});

// pagination
const pagination = computed((): (number | null)[] => {
  const res = [];
  const minpaginationElems = 5 + props.rangeSize * 2;

  let rangeStart =
    props.pages <= minpaginationElems ? 1 : props.modelValue - props.rangeSize;
  let rangeEnd =
    props.pages <= minpaginationElems
      ? props.pages
      : props.modelValue + props.rangeSize;

  rangeEnd = rangeEnd > props.pages ? props.pages : rangeEnd;
  rangeStart = rangeStart < 1 ? 1 : rangeStart;

  if (props.pages > minpaginationElems) {
    const isStartBoundaryReached = rangeStart - 1 < 3;
    const isEndBoundaryReached = props.pages - rangeEnd < 3;

    if (isStartBoundaryReached) {
      rangeEnd = minpaginationElems - 2;
      for (let i = 1; i < rangeStart; i++) {
        res.push(i);
      }
    } else {
      res.push(1);
      res.push(null);
    }

    if (isEndBoundaryReached) {
      rangeStart = props.pages - (minpaginationElems - 3);
      for (let i = rangeStart; i <= props.pages; i++) {
        res.push(i);
      }
    } else {
      for (let i = rangeStart; i <= rangeEnd; i++) {
        res.push(i);
      }
      res.push(null);
      res.push(props.pages);
    }
  } else {
    for (let i = rangeStart; i <= rangeEnd; i++) {
      res.push(i);
    }
  }

  return res;
});

function updatePageHandler(params: number) {
  emit("update:modelValue", params);
}

// controls
const isPrevcontrolsActive = computed((): boolean => {
  return props.modelValue > 1;
});
const isNextcontrolsActive = computed((): boolean => {
  return props.modelValue < props.pages;
});

// function goToFirst(): void {
//   if (isPrevcontrolsActive.value) {
//     emit("update:modelValue", 1);
//   }
// }
function goToPrev(): void {
  if (isPrevcontrolsActive.value) {
    emit("update:modelValue", props.modelValue - 1);
  }
}

// function goToLast(): void {
//   if (isNextcontrolsActive.value) {
//     emit("update:modelValue", props.pages);
//   }
// }
function goToNext(): void {
  if (isNextcontrolsActive.value) {
    emit("update:modelValue", props.modelValue + 1);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isTopSlot.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "topSlot")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "pagination-layout",
      style: _normalizeStyle({
        'padding-bottom': isLeftSlot.value ? 0.75 + 'rem' : 0,
      })
    }, [
      (__props.showMoreElements)
        ? (_openBlock(), _createBlock(TirPmPaginationShowMoreElements, {
            key: 0,
            class: "show-more-elements",
            options: __props.options,
            countElements: innerCountElements.value,
            "onUpdate:countElements": _cache[0] || (_cache[0] = ($event: any) => ((innerCountElements).value = $event))
          }, null, 8, ["options", "countElements"]))
        : _createCommentVNode("", true),
      (isLeftSlot.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "leftSlot")
          ]))
        : _createCommentVNode("", true),
      (!props.isSmall)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
            _createElementVNode("li", {
              class: _normalizeClass(["pagination__control pagination-control", { 'pagination-control--active': isPrevcontrolsActive.value }]),
              onClick: goToPrev
            }, [
              _createVNode(_unref(ChevronLeftIcon))
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagination.value, (page) => {
              return (_openBlock(), _createBlock(TirPmPaginationItem, {
                key: `pagination-page-${page}`,
                page: page,
                current: __props.modelValue,
                onUpdate: updatePageHandler
              }, null, 8, ["page", "current"]))
            }), 128)),
            _createElementVNode("li", {
              class: _normalizeClass(["pagination__control pagination-control", { 'pagination-control--active': isNextcontrolsActive.value }]),
              onClick: goToNext
            }, [
              _createVNode(_unref(ChevronRightIcon))
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (props.isSmall)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["pagination__control pagination-control", { 'pagination-control--active': isPrevcontrolsActive.value }]),
              onClick: goToPrev
            }, [
              _createVNode(_unref(ChevronLeftIcon))
            ], 2),
            _createTextVNode(" " + _toDisplayString(__props.modelValue) + " из " + _toDisplayString(pagination.value.at(-1)) + " страниц ", 1),
            _createElementVNode("div", {
              class: _normalizeClass(["pagination-control", { 'pagination-control--active': isNextcontrolsActive.value }]),
              onClick: goToNext
            }, [
              _createVNode(_unref(ChevronRightIcon))
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}
}

})